var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center w-full px-8 py-4 hover:bg-lightGray",on:{"click":function($event){return _vm.$emit('click')}}},[_c('ChevronIcon',{staticClass:"rotate-[90deg] w-4 h-4 absolute"}),_vm._v(" "),_c('h5',{staticClass:"pl-8 pr-8 font-semibold"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }